import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import {Factory as ExposureTabsFactory} from './components/factory';
import {connect} from 'react-redux';

class ExposureTabs extends Component {
    render() {
        const {sportConfig} = this.props;
        let {className = ''} = this.props;

        const ExposureTabs = ExposureTabsFactory.getComponent(sportConfig);

        let content = null;
        if (ExposureTabs) {
            content = <ExposureTabs />;
            className += ' table-tab-holder';
        }

        return <div className={className}>{content}</div>;
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    return {
        sportConfig,
    };
}

const ExposureTabsComponent = connect(mapStatesToProps)(ExposureTabs);

export {ExposureTabsComponent};
